var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDiscount = function SvgIconDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.293 11.595 7.099 7.099c.39.39 1.03.39 1.42 0l9.464-9.466c.39-.39.71-1.161.71-1.713V1.004C18.986.452 18.535 0 17.983 0h-6.511c-.552 0-1.323.32-1.714.71L.293 10.175c-.39.39-.39 1.03 0 1.42Zm14.96-8.839a.976.976 0 1 1 1.954 0 .976.976 0 0 1-1.953 0Z",
    fill: "#0000B4"
  })));
};
export default SvgIconDiscount;